import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { get, getIn, List, Map } from 'immutable';
import { generateForm } from '../../form/Form';
import { createBridge, fetchAdapters, fetchBridge, updateBridge } from '../../../apis';
import { buildPropertyFields } from '../../form/Form.helpers';

var dataSources = function dataSources(_ref) {
  var bridgeSlug = _ref.bridgeSlug,
      agentSlug = _ref.agentSlug,
      adapterClass = _ref.adapterClass;
  return {
    bridge: {
      fn: fetchBridge,
      params: bridgeSlug && [{
        agentSlug: agentSlug,
        bridgeSlug: bridgeSlug,
        include: 'details'
      }],
      transform: function transform(result) {
        return result.bridge;
      }
    },
    adapters: {
      fn: fetchAdapters,
      params: [{
        include: 'details',
        type: 'bridge',
        agentSlug: agentSlug
      }],
      transform: function transform(result) {
        return result.adapters;
      }
    },
    adapterProperties: {
      fn: function fn(adapters, bridge) {
        var appliedAdapterClass = bridge ? bridge.get('adapterClass') : adapterClass;
        var adapter = adapters.find(function (adapter) {
          return adapter.get('class') === appliedAdapterClass;
        });
        return adapter ? List(adapter.get('properties')) : List();
      },
      params: function params(_ref2) {
        var adapters = _ref2.adapters,
            bridge = _ref2.bridge;
        return (!bridgeSlug || bridge) && adapters && [adapters, bridge];
      }
    }
  };
};

var handleSubmit = function handleSubmit(_ref3) {
  var bridgeSlug = _ref3.bridgeSlug,
      agentSlug = _ref3.agentSlug;
  return function (values) {
    return (bridgeSlug ? updateBridge : createBridge)({
      bridgeSlug: bridgeSlug,
      agentSlug: agentSlug,
      bridge: values.toJS()
    }).then(function (_ref4) {
      var bridge = _ref4.bridge,
          error = _ref4.error;

      if (error) {
        throw error.statusCode === 400 && error.message || 'There was an error saving the bridge';
      }

      return bridge;
    });
  };
};

var fields = function fields(_ref5) {
  var bridgeSlug = _ref5.bridgeSlug,
      adapterClass = _ref5.adapterClass;
  return function (_ref6) {
    var bridge = _ref6.bridge,
        adapters = _ref6.adapters,
        adapterProperties = _ref6.adapterProperties;

    if (adapterProperties) {
      var _buildPropertyFields = buildPropertyFields({
        isNew: !bridge,
        properties: adapterProperties,
        getName: function getName(property) {
          return property.get('name');
        },
        getRequired: function getRequired(property) {
          return property.get('required');
        },
        getSensitive: function getSensitive(property) {
          return property.get('sensitive');
        },
        getOptions: function getOptions(property) {
          return property.get('options');
        },
        getValue: function getValue(property) {
          return getIn(bridge, ['properties', property.get('name')], '');
        }
      }),
          propertiesFields = _buildPropertyFields.propertiesFields,
          propertiesSerialize = _buildPropertyFields.propertiesSerialize;

      return [{
        name: 'slug',
        label: 'Bridge Slug',
        type: 'text',
        required: true,
        initialValue: get(bridge, 'slug', ''),
        pattern: /^[a-z\d-]+$/,
        patternMessage: 'Bridge Slug may only contain letters, numbers, and dashes',
        helpText: 'Unique name used in the bridge path.'
      }, {
        name: 'adapterClass',
        label: 'Adapter Class',
        type: 'text',
        enabled: false,
        required: false,
        initialValue: bridge ? bridge.get('adapterClass') : adapterClass,
        options: adapters.map(function (adapter) {
          return Map({
            value: adapter.get('class'),
            label: adapter.get('name')
          });
        })
      }].concat(_toConsumableArray(propertiesFields), [{
        name: 'properties',
        visible: false,
        initialValue: get(bridge, 'properties', {}),
        serialize: propertiesSerialize
      }]);
    }
  };
};

export var BridgeForm = generateForm({
  formOptions: ['bridgeSlug', 'adapterClass', 'agentSlug'],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});
BridgeForm.displayName = 'BridgeForm';